<template>
  <div class="mb-2">
    <aha-checkbox
      @change="handleEnableGetPresentation"
      v-model="checkboxConversationPresenterShare"
      :disabled="isDisableEditPresentation"
    >
      <span>
        {{ $i18nPresenter.t('Allow comments') }}
        <AhaSvg
          class="mb-1 ml-1 text-secondary-20"
          name="question"
          v-tooltip="$i18nPresenter.t('Anyone with the link can leave a comment on the shared presentation')"
        />
      </span>
    </aha-checkbox>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import PresentationApi from '@/api/presentation'
import Utils from '@/util'
import eventCategories from '@/constant/eventCategories'

export default {
  components: {
  },
  props: {
    presentation: {
      type: Object,
      required: false,
      default() {
        return null
      },
    },
    from: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      checkboxConversationPresenterShare: true,
    }
  },
  mounted() {
    this.checkboxConversationPresenterShare = !this.presentation.disableConversationPresenterShare
  },
  computed: {
    ...mapState({
      currentUser: (state) => state.currentUser,
      isDisableEditPresentation: (state) => state.isDisableEditPresentation,
    }),
    isOwnerOfPresentation() {
      if (this.currentUser.id === this.presentation.userId) {
        return true
      }
      return false
    },
  },
  methods: {
    handleEnableGetPresentation(value) {
      if (this.from === 'SideCenterShareSlides') {
        Utils.mixpanelTracking(
          eventCategories.PRESENTATION_EDITOR,
          'Share menu > Share slides > Allow comment',
          !!value,
          null,
          {
            presentationId: this.presentation.id,
            userId: this.currentUser.id,
            isPresentationOwner: this.presentation.userId === this.currentUser.id,
          },
        )
      }
      PresentationApi.patchPresentation(this.presentation.id, {
        disableConversationPresenterShare: !value,
      })
    },
  },
}
</script>

<style lang="scss" scoped>
</style>
